import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import MobileSettingsForm from '../../../components/SiteAdmin/MobileSettingsForm/MobileSettingsForm';
import ConfigSettingsForm from '../../../components/SiteAdmin/ConfigSettingsForm';
import Loader from '../../../components/Common/Loader/Loader';

import s from './MobileSettings.css';

import getSiteSettings from './getSiteSettings.graphql'
import messages from '../../../locale/messages';

export class MobileSettings extends Component {

  render() {
    const {
      getSiteSettings: { loading, getSiteSettings, refetch },
      getConfigSettings: { loading: configLoading, getSiteSettings: getConfigSettingsData, refetch: configRefetch },
    } = this.props;

    if (loading || configLoading) {
      return <Loader type={"page"} show={true} />
    }

    let mobileSettingsCollection = {}
    getSiteSettings && getSiteSettings.results && getSiteSettings.results.length > 0 && getSiteSettings.results.map((item) => {
      mobileSettingsCollection[item.name] = item.value
    })

    let configSettingsCollection = {}
    getConfigSettingsData && getConfigSettingsData.results && getConfigSettingsData.results.length > 0 && getConfigSettingsData.results.map((item) => {
      configSettingsCollection[item.name] = item.value
    })

    return (
      <div className={s.root}>
        <div className={cx(s.container, 'paddingBottomLg')}>
          <div className={cx(s.heading, 'textAlignRightRTL')}>
            <FormattedMessage {...messages.systemSettingsPageHeading} />
          </div>
          <div className={s.spaceTop5}>
            <MobileSettingsForm refetch={refetch} initialValues={{ ...mobileSettingsCollection, subtractTime: configSettingsCollection.subtractTime, maxDistance: configSettingsCollection.maxDistance, maxSearchDuration: configSettingsCollection.maxSearchDuration, retryInterval: configSettingsCollection.retryInterval, maxWeight: configSettingsCollection.maxWeight }} />
            <ConfigSettingsForm refetch={configRefetch} getSiteSettings={getConfigSettingsData} initialValues={{ ...configSettingsCollection }} />
          </div>
        </div>
      </div>
    )
  }
}


export default compose(
  withStyles(s),
  graphql(getSiteSettings, {
    name: 'getSiteSettings',
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: { type: 'site_Settings' },
      ssr: true,
    }),
  }),
  graphql(getSiteSettings, {
    name: 'getConfigSettings',
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: { type: 'config_settings' },
      ssr: true,
    }),
  })
)(MobileSettings)
